export default {"src":"/_next/static/media/moon.2e2c80f6.svg","height":512,"width":384,"blurWidth":0,"blurHeight":0};